<template>
  <el-container class="login-page">
    <img src="../assets/images/loginBackground.jpeg" :width="bgSize.width" :height="bgSize.height" alt="bg">
    <el-col class="io-background"></el-col>
    <el-col class="io-box">
      <span class="io-title">综合能碳管理平台</span>

      <el-input class="io-name-input" placeholder="请输入您的用户名" v-model="username"/>

      <el-input class="io-psw-input" placeholder="请输入您的密码" type="password" v-model="password"/>

      <el-button class="login-button" @click="login">登 录</el-button>

      <div class="link-info" @click="openLinkDialog">获取测试账号</div>
    </el-col>
<!--    <el-col class="erweima-class">-->
<!--      <img src="../assets/images/erweima.png" width="150px" height="150px" alt="bg">-->
<!--      <span>扫码下载APP</span>-->
<!--    </el-col>-->
    <el-col class="beian-class" @click.native="toIcpAddr">
      <span>鄂ICP备2022007980号-1</span>
    </el-col>

    <el-dialog class="common-dialog" :append-to-body="true" :close-on-click-modal="true" width="720px" center
               title="获取测试账号" :visible.sync="dialogVisible" :before-close="handleClose">
      <div class="info-box">
        <div class="info-line welcome">感谢您的关注！</div>
        <div class="info-line">请通过以下方式获取测试账号：</div>
        <div class="info-line">1. 联系售前：18627018350（张经理）（微信同号）</div>
        <div class="info-line">2. 微信号：home_child</div>
        <div class="info-line">3. 邮箱：yukui_tech@163.com</div>
        <div class="info-line">我们的工作人员会尽快与您联系并提供测试账号。</div>
        <div class="info-line">感谢您的支持与理解！</div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import md5 from 'js-md5';
import {Message} from 'element-ui'
import {routerTo} from '../router';

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      isAutoLogin: false,
      selCompanyId: 'test',
      dialogVisible: false,
      bgSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  created() {
    this.addEnterKeyEvent();
  },
  beforeDestroy() {
    onkeydown = null
  },
  destroyed() {
    onkeydown = null
  },
  methods: {
    login() {
      let userInfo = {
        password: md5(this.password),
        userAccount: this.username
      };
      this.$api.systemManage.loginIn(userInfo).then(res => {
        if (res.code === 200) {
          sessionStorage.setItem('loginTimeStamp', '' + new Date().getTime());
          sessionStorage.setItem('token', res.data.token);
          // 登录前清除页面已存登录数据
          let loginData = {'userInfo': res.data};
          loginData.userInfo.userId = res.data.userId;
          loginData.userInfo.employeeName = res.data.userName;
          loginData.userInfo.userAccount = res.data.userAccount;
          loginData.userInfo.icon = res.data.icon;
          sessionStorage.setItem('loginStore', JSON.stringify(loginData));
          this.$set(res.data, 'loginData', loginData);
          routerTo(this.$router, 'EnergyEfficiency');
        } else {
          Message.warning(res.message);
        }
      })
    },
    addEnterKeyEvent() {
      let _self = this;
      onkeydown = function(e) {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
          _self.login();
        }
      }
    },
    toIcpAddr() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    },
    openLinkDialog() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      console.log('close');
      done();
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.bgSize.width = window.innerWidth;
      this.bgSize.height = window.innerHeight;
      // console.log(window.innerWidth + "," + window.innerHeight)
    })
  }
}
</script>

<style scoped>
  .login-page{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .io-background{
    position: absolute;
    left: 37%;
    top: 24%;
    width: 26%;
    height: 40%;
    background: rgba(220, 220, 220, 1);
    box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.7);
    opacity: 0.6;
    border-radius: 20px;
  }
  .io-box{
    position: absolute;
    left: 36%;
    top: 20%;
    width: 28%;
    height: 57.41%;
  }
  .io-title{
    position: absolute;
    top: 18%;
    left: 15.63%;
    width: 69.06%;
    height: 5.63%;
    font-size: 28px;
    font-weight: bold;
    line-height: 50px;
    font-family: PingFang-SC-Regular,fantasy;
    cursor: default;
    color: rgba(40, 40, 40, 1);
  }
  .io-name-input{
    position: absolute;
    top: 30%;
    left: 20%;
    width: 60%;
    height: 20px;
    font-size: 16px;
    color: rgba(40, 40, 40, 1);
  }
  .io-psw-input{
    position: absolute;
    top: 44%;
    left: 20%;
    width: 60%;
    height: 20px;
    font-size: 16px;
    color: rgba(40, 40, 40, 1);
  }
  .divider1{
    position: absolute;
    top: 36.73%;
    left: 5.78%;
    width: 87.66%;
  }
  .divider2{
    position: absolute;
    top: 54.2%;
    left: 5.78%;
    width: 87.66%;
  }
  .auto-login-check{
    position: absolute;
    top: 60.44%;
    left: 5.78%;
    display:flex;
    font-size: 20px;
    color: white;
    align-items: center;
  }
  .company-selector{
    margin: 0 8px 0 58px;
    font-size: 20px;
    background: transparent;
  }
  .company-refresh{
    padding: 6px;
    font-size: 20px;
    font-weight: bold;
    background: transparent;
  }
  .login-button{
    position: absolute;
    top: 58%;
    left: 32%;
    width: 36%;
    height: 8%;
    background: transparent;
    color: rgb(250, 250, 250);
    border: 2px solid rgb(102, 205, 253);
    border-radius: 8px;
    font-size: 16px;
  }
  .login-button:hover{
    background: rgba(102, 205, 253, 0.8);
    color: rgb(250, 250, 250);
  }
  .link-info {
    position: absolute;
    top: 70%;
    left: 5.78%;
    font-size: 16px;
    color: #dedede;
    cursor: pointer;
    text-decoration: underline;
  }
  .link-info:hover {
    color: #97c6ff;
  }
  .erweima-class {
    position: absolute;
    bottom: 7%;
    right: 7%;
    width: 150px;
    height: 180px;
    color: #ffffff;
    line-height: 30px;
  }
  .beian-class {
    position: absolute;
    bottom: 10px;
    left: calc(50% - 110px);
    width: 220px;
    height: 30px;
    color: #ffffff;
    font-size: 16px;
    line-height: 32px;
    cursor: pointer;
  }
  input[type=checkbox] {
    margin-top: 8px;
    margin-right: 20px;
    -ms-transform: scale(1.8); /* IE */
    -moz-transform: scale(1.8); /* FireFox */
    -webkit-transform: scale(1.8); /* Safari and Chrome */
    -o-transform: scale(1.8); /* Opera */
  }

  .info-box {
    padding: 20px;
  }
  .info-line {
    line-height: 30px;
  }
  .welcome {
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue